import React, { useCallback, useEffect, useState } from "react";
import { Typography } from "antd";
import SVGIcon from "../../constants/SVGIcon";
import CustomTextfield from "../../common/input/custom-textfield/custom-textfield";
import CustomTable from "../../common/custom-table/custom-table";
import { getContactQueries } from "../../services/product_demo_requests";
import { formatDateToShortReadable } from "../../utils/format-date/format-date";
import debounce from "lodash.debounce";
import ContactQueriesDrawer from "./components/contact-queries-drawer/contact-queries-drawer";
import CustomButton from "../../common/custom-button/custom-button";
import styles from "./contact-queries.module.css";

const ContactQueries = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [searchFieldValue, setSearchFieldValue] = useState("");
  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [contactQueryList, setContactQueryList] = useState([]);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [viewDetailsInfo, setViewDetailsInfo] = useState({});

  const columns = [
    {
      title: "Full name",
      dataIndex: "name",
      key: "name",
      render: (value) => value || "-",
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      align: "center",
      render: (value) => value || "-",
    },
    {
      title: "Phone No.",
      dataIndex: "phone_number",
      key: "phone_number",
      align: "center",
      render: (value) => value || "-",
    },
    {
      title: "School/Organization",
      dataIndex: "institution_name",
      key: "institution_name",
      align: "center",
      render: (value) => value || "-",
    },
    {
      title: "Date Requested",
      dataIndex: "created_at",
      key: "created_at",
      align: "center",
      render: (date) => formatDateToShortReadable(date),
    },
    {
      title: "Action",
      key: "action_child",
      align: "center",
      render: (_, record) => (
        <div className={styles.viewDetailsWrapper}>
          <CustomButton
            title="View Details"
            size="small"
            onClick={() => handleViewDetails(record)}
            className={styles.viewDetailsBtn}
          />
        </div>
      ),
    },
  ];

  const debouncedSearch = useCallback(
    debounce((search_term) => {
      setSearchTerm(search_term);
    }, 500),
    []
  );

  const handleSearchChange = (e) => {
    setSearchFieldValue(e.target.value);
    debouncedSearch(e.target.value);
  };

  useEffect(() => {
    const timeOut = setTimeout(() => {
      setPageNo(1);
      fetchContactQueries();
    }, 500);
    return () => {
      clearTimeout(timeOut);
    };
  }, [searchTerm]);

  const fetchContactQueries = async (
    tempPage = pageNo,
    tempPageSize = pageSize
  ) => {
    try {
      setLoading(true);
      const payload = {
        page: tempPage,
        pageSize: tempPageSize,
      };

      if (searchTerm) {
        payload.search = searchTerm;
      }

      const response = await getContactQueries(payload);
      if (response?.data) {
        const consolidated_list = response?.data?.data;
        setContactQueryList(consolidated_list);
        setTotalCount(response?.data?.data?.totalRecords);
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      setLoading(false);
    }
  };

  const handleChangePage = (page, pageSize) => {
    setPageNo(page);
    setPageSize(pageSize);
    fetchContactQueries(page, pageSize);
  };
  
  const handleCloseDrawer = () => {
    setOpenDrawer(false);
    setViewDetailsInfo(null);
  };

  const handleViewDetails = (record) => {
    setOpenDrawer(true);
    setViewDetailsInfo(record);
  }
 
  return (
    <div>
      <div className={styles.headerContainer}>
        <Typography className={styles.title}>Contact Us Queries</Typography>
        <div className={styles.filterContainer}>
          <CustomTextfield
            id={"search"}
            type={"text"}
            className={styles.inputField}
            prefix={
              <SVGIcon
                name={"search-icon"}
                width={"20px"}
                height={"20px"}
                className="anticon"
                stroke={"#667085"}
              />
            }
            placeholder={"Search"}
            allowClear
            value={searchFieldValue}
            onChange={handleSearchChange}
          />
        </div>
      </div>

      <div className={styles.tableContainer}>
        <CustomTable
          columns={columns}
          dataSource={contactQueryList}
          total={totalCount}
          loading={loading}
          pageSize={pageSize}
          currentPage={pageNo}
          handlePageChange={handleChangePage}
        />
      </div>

      {openDrawer && (
        <ContactQueriesDrawer
          open={openDrawer}
          onClose={handleCloseDrawer} 
          viewDetailsInfo={viewDetailsInfo}
        />
      )}
    </div>
  );
};

export default ContactQueries;
